import styled, { css } from 'styled-components'

import { Color } from 'root-constants'
import { TValueOf } from 'root-types'

export const TERMS_LINKS_GROUP_VARIANT = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const

export type TTermsLinksGroupVariant = TValueOf<typeof TERMS_LINKS_GROUP_VARIANT>

type TContainerProps = {
  $variant: TTermsLinksGroupVariant
}

type TSeparatorProps = {
  $variant: TTermsLinksGroupVariant
}

const lightStyles = css`
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.5px;
  color: ${Color.WHITE};
  opacity: 0.5;

  a {
    color: inherit;
    letter-spacing: 0.5px;
    text-decoration: underline;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`

const darkStyles = css`
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  color: ${Color.INK_LIGHT};
  margin-top: auto;

  a {
    color: ${Color.INK_DARKEST};
    text-decoration: underline;
    padding-top: 8px;
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`

export const StyledTermsLinksGroup = {
  Container: styled.div<TContainerProps>`
    ${({ $variant }) =>
      $variant === TERMS_LINKS_GROUP_VARIANT.LIGHT ? lightStyles : darkStyles}
  `,
  Separator: styled.span<TSeparatorProps>`
    display: inline-flex;
    width: 1px;
    vertical-align: middle;

    ${({ $variant }) =>
      $variant === TERMS_LINKS_GROUP_VARIANT.LIGHT
        ? css`
            height: 12px;
            background-color: ${Color.WHITE};
            margin: 0 4px;
          `
        : css`
            height: 16px;
            background-color: ${Color.SKY_DARK};
            margin: 0 8px;
          `}
  `,
}
